import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const t = a((s, e) => /* @__PURE__ */ r.jsx(
  c,
  {
    ref: e,
    ...s,
    image: (o) => /* @__PURE__ */ r.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ r.jsxs(
            "mask",
            {
              id: "mask0_2974_3644",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ r.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M12.09 0H3.9C1.75 0 0 1.75 0 3.9v8.19c0 2.15 1.75 3.9 3.9 3.9h8.19c2.15 0 3.9-1.75 3.9-3.9V3.9c0-2.15-1.75-3.9-3.9-3.9m2.4 12.09c0 1.32-1.08 2.4-2.4 2.4H3.9c-1.32 0-2.4-1.08-2.4-2.4V3.9c0-1.32 1.08-2.4 2.4-2.4h8.19c1.32 0 2.4 1.08 2.4 2.4z"
                  }
                ),
                /* @__PURE__ */ r.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M8 10.3c.41 0 .75-.34.75-.75v-5.8a.749.749 0 1 0-1.5 0v5.8c0 .41.33.75.75.75M8.01 13.05a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ r.jsx("g", { mask: "url(#mask0_2974_3644)", children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyErrorIcon";
export {
  t as AgencyErrorIcon,
  t as default
};
//# sourceMappingURL=index.js.map
